import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface Toast {
  state: string;
  title: string;
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private toastSubject = new Subject<Toast>();
  toast$ = this.toastSubject.asObservable();

  // STATES: success | error | warning | information
  showToast(state: string, title: string, message: string) {
    this.toastSubject.next({ state, title, message });
  }
}
